import { useRef } from 'react';

export const usePrevious = <T>(newValue: T) => {
  const ref = useRef<{ value: T; prev: T | undefined }>({
    value: newValue,
    prev: undefined,
  });

  // eslint-disable-next-line react-hooks/refs
  const prevValue = ref.current.prev;

  // Update ref during render for tracking previous value
  // This is a safe pattern for usePrevious hooks
  // eslint-disable-next-line react-hooks/refs
  if (ref.current.value !== newValue) {
    // eslint-disable-next-line react-hooks/refs
    ref.current.prev = ref.current.value;
    // eslint-disable-next-line react-hooks/refs
    ref.current.value = newValue;
  }

  // eslint-disable-next-line react-hooks/refs
  return prevValue;
};
